import {ExperienceLevel, Job, Person, PersonType, Profile, ProfileSkill, Role, Scope} from "@betrue/shared/interfaces";
import {JOBS} from "./jobs.dataset";
import {PROFILE_SKILLS} from "./profile-skills.dataset";
import {randomData} from "./helpers.dataset";
import {v4 as uuidv4} from 'uuid';

export const PERSONS: Person[] = [
  {
    id: uuidv4(),
    email: 'selim.bensenocui@betrue.fr',
    role: Role.USER, scope: Scope.PARTNER,
    lastName: 'Bensenouci',
    firstName: 'selim',
    removed: false,
    personType: PersonType.PHYSICAL,
    profile: undefined,
    phone: undefined,
    externalId: undefined, chatId: undefined, chatUsername: undefined,
    jobTitle: randomData<Job>(JOBS, 1)[0].label,
  },
  {
    id: uuidv4(),
    email: 'selim.bensenocui@betrue.fr',
    role: Role.USER, scope: Scope.PARTNER,
    lastName: 'Bensenouci',
    removed: false,
    firstName: 'selim',
    personType: PersonType.PHYSICAL,
    profile: undefined,
    phone: undefined,
    externalId: undefined, chatId: undefined, chatUsername: undefined,
    jobTitle: randomData<Job>(JOBS, 1)[0].label,
  },
  {
    id: uuidv4(),
    removed: false,
    email: 'cecile.guyart@betrue.fr',
    role: Role.USER, scope: Scope.PARTNER,
    lastName: 'Guyart',
    firstName: 'cecile',
    personType: PersonType.PHYSICAL,
    profile: undefined,
    phone: undefined,
    externalId: undefined, chatId: undefined, chatUsername: undefined,
    jobTitle: randomData<Job>(JOBS, 1)[0].label,
  }, {
    id: uuidv4(),
    removed: false,
    email: 'amandine.juston@betrue.fr',
    role: Role.USER, scope: Scope.EMPLOYEE,
    lastName: 'Juston',
    firstName: 'Amandine',
    personType: PersonType.PHYSICAL,
    profile: undefined,
    phone: undefined,
    externalId: undefined, chatId: undefined, chatUsername: undefined,
    jobTitle: randomData<Job>(JOBS, 1)[0].label,
  }
]
export const PROFILES = [
  {
    id: uuidv4(),
    job: randomData<Job>(JOBS, 1)[0],
    experienceLevel: ExperienceLevel.NONE,
    person: PERSONS[0],
    rating: 0,
    skills: randomData<ProfileSkill>(PROFILE_SKILLS, 8),
    mainsSkills: [],
    price: 300
  },
  {
    id: uuidv4(),
    job: randomData<Job>(JOBS, 1)[0],
    experienceLevel: ExperienceLevel.EXPERT,
    rating: 0,
    person: PERSONS[1],
    skills: randomData<ProfileSkill>(PROFILE_SKILLS, 7),
    mainsSkills: [],
    price: 300
  },
  {
    id: uuidv4(),
    job: randomData<Job>(JOBS, 1)[0],
    experienceLevel: ExperienceLevel.INTERMEDIATE,
    person: PERSONS[2],

    rating: 0,
    skills: randomData<ProfileSkill>(PROFILE_SKILLS, 3),
    mainsSkills: [],
    price: 300
  },
  {
    id: uuidv4(),
    job: randomData<Job>(JOBS, 1)[0],
    experienceLevel: ExperienceLevel.ENTRY,
    rating: 0,
    person: PERSONS[2],
    skills: randomData<ProfileSkill>(PROFILE_SKILLS, 5),
    mainsSkills: randomData<ProfileSkill>(PROFILE_SKILLS, 3),
    price: 300
  }
] as Profile[]
